import Index from '../../views/main/library/Index'
import Create from '../../views/main/library/Create'
import Edit from '../../views/main/library/Edit';

export default [
  {
    component: Index,
    name: 'library-index',
    path: '/library',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
      module: 'library',
    }
  },
  {
    component: Create,
    name: 'library-create',
    path: '/library/create',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
      module: 'library',
    }
  },
  {
    component: Edit,
    name: 'library-edit',
    path: '/library/edit/:id',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
      module: 'library',
    }
  },
]
